/**
 * Whether the crouch key is held or tapped.
 *
 * Writes to [verbHoldModes](../../../core/input/verbHoldModes.ts), the same way the other two
 * hold-mode knobs do. A stance is the one of the three that lasts: a player who spends a fight
 * behind cover is holding control for the whole of it, and a toggle is what makes that a decision
 * rather than a grip.
 *
 * What a toggled crouch cannot do is stand you up under a ceiling. Headroom is the world's answer
 * and the movement machine keeps making it per tick, so a latched crouch under a pipe stays down
 * until there is somewhere to stand, exactly as a held one does.
 */

import { choiceApply } from '@/ui/settings/controls/choiceButtons';
import { DEFAULT_HOLD_MODE, setHoldMode } from '@/core/input/verbHoldModes';
import { HOLD_MODE_CHOICE } from '@/ui/settings/holdModeOptions';
import { SETTING_CROUCH_HOLD_LABEL, SETTING_CROUCH_HOLD_HINT } from '@/text/settingsText';
import type { SettingDefinition } from '@/ui/settings/settingContract';

export const CROUCH_HOLD_MODE: SettingDefinition = {
  id: 'crouchHoldMode',
  section: 'controls',
  label: SETTING_CROUCH_HOLD_LABEL,
  hint: SETTING_CROUCH_HOLD_HINT,
  control: HOLD_MODE_CHOICE,
  defaultValue: DEFAULT_HOLD_MODE,
  apply: choiceApply((value: string): void => {
    setHoldMode('crouch', value);
  }),
};
